// extracted by mini-css-extract-plugin
export default {"Form":"partner_Form__Pxl-m"};